import React, {useEffect, useState} from 'react';
import {Backdrop, CircularProgress,  Menu, MenuItem, Paper} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {useDispatch, useSelector} from "react-redux";
import {
    getExcelDocumentNodes,
    getFolderNodes,
    selectLoading,
    selectNormativeArticles,
    selectNormativeDocuments,
    selectNormativeDocumentTree,
} from "../../redux/reducers/normative-documents-reducer.js";
import ViewStreamIcon from '@material-ui/icons/ViewStream';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useDialog } from '../../hooks/useDialog';
import DocumentsTreeViewForUser from './DocumentsTreeViewForUser.jsx';
import CheckListFillDialog from '../DocumentsTreeDialogs/CheckListFillDialog.jsx';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        width: '100%',
    },
    header: {
        paddingBottom: theme.spacing(1)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))

const AddMenu = (props) => {
    const {anchorEl, handleClose, title, onAddNormativeChapterButtonClick, onAddNormativeArticleButtonClick} = props

    const handleAddNormativeChapterButtonClick = () => {
        handleClose()
        onAddNormativeChapterButtonClick()
    }

    const handleAddNormativeArticleButtonClick = () => {
        handleClose()
        onAddNormativeArticleButtonClick()
    }

    return (
        <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
        >
            <MenuItem onClick={handleAddNormativeChapterButtonClick}>Добавить главу в {title}</MenuItem>
            <MenuItem onClick={handleAddNormativeArticleButtonClick} disabled={title === 'корень документа'}>Добавить
                пункт в {title}</MenuItem>
        </Menu>
    );
}

const TreeCheckListForUser= ({
    checkListId, 
    setFieldValue,
    content,
    value,
    variable,
}) => {
    
    const classes = useStyles()
    const [cutNode, setCutNode] = useState('')
    const [useArticles, setUseArticles] = useState([])
    const [id, setId] = useState([])
    const [idChapter, setIdChapter] = useState([])

    const documentNodes = useSelector(selectNormativeDocumentTree)
    const normativeDocuments = useSelector(selectNormativeDocuments)
    const normativeArticles = useSelector(selectNormativeArticles)
    const loading = useSelector(selectLoading)

    const fillChaptersDialog = useDialog()

    const dispatch = useDispatch()

    const typeIcons = {
        normativeChapter: ViewStreamIcon,
        normativeArticle: FiberManualRecordIcon
    }

    const iconTooltips = {
        normativeChapter: 'Глава',
        normativeArticle: 'Пункт'
    }

    const toolbarCallbacks = {
        onDoubleClick: (nodeID) => async () => {
            const [type, id] = nodeID.split('.')
            const useChapter = documentNodes.filter(article => article.id == id)
            setIdChapter(useChapter)
            setId(id)
            const getArticles = normativeArticles.filter(article => article.excel_chapter == id && article.type === "normativeArticle")
            setUseArticles(getArticles)
            fillChaptersDialog.handleOpen()
        }
    }

    useEffect(() => {
        if (normativeDocuments.length === 0) {
            dispatch(getFolderNodes())
        }
    }, [normativeDocuments])

    useEffect(() => {
        dispatch(getExcelDocumentNodes(checkListId))
    }, [checkListId])


    const traverseDFRecursive = (node) => {
        if (node.children !== null) {
            if (node.children.lenght !== 0) {
                let newChild = []
            node.children.map((child) => {
                if (child.type === 'normativeChapter') {
                    newChild.push(child)
                }
            })
            node.children = [...newChild]
            node.children.map((node) => traverseDFRecursive(node))
            }
            
        }
   
   }

    useEffect(() => {

        const howComponent = (el) => {
            if (el.type === 'checkbox-field') 
                return false
            else return ''
        } 

        let stroke = []
        if (value === '') {
            let column = {}
            content.offenseWindow.map((el) => {
                column = {...column, ...{[el.variable]: howComponent(el)}}
            })
           
            documentNodes.map((el) => {
               
                const number = el.id

                const getArticlesChapter = normativeArticles.filter(article => article.excel_chapter == number && article.type === "normativeArticle")

                let goodArticles = []

                getArticlesChapter.map((article) => {

                    let number = article.number.replace('_','')
                    
                    let goodRow = {
                            id: number,
                            name: article.full_text,
                            ...column
                    }
                    goodArticles.push(goodRow)
                })

                const newEl = { [number] : goodArticles}

                stroke.push(newEl)

            })
            
            setFieldValue(variable, stroke)
        }

    },[documentNodes])

 

    useEffect(() => {
        
        if (documentNodes !== null) {
            documentNodes.map((node) => {
                traverseDFRecursive(node)
            })    
        }        
    },[documentNodes])

    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={Boolean(loading)}>
                <CircularProgress color={'inherit'}/>
            </Backdrop>
            <CheckListFillDialog
                open={fillChaptersDialog.open}
                onClose={fillChaptersDialog.handleClose}
                initialValues={useArticles}
                offenseWindow={content.offenseWindow}
                value={value}
                setFieldValue={setFieldValue}
                variable={variable}
                id={id}
                idChapter={idChapter}
                allArticles={normativeArticles}
            />
            <Paper className={classes.paper}>
                <DocumentsTreeViewForUser
                    nodes={loading ? [] : documentNodes}
                    typeIcons={typeIcons}
                    iconTooltips={iconTooltips}
                    toolbarCallbacks={toolbarCallbacks}
                    isAbleToPaste={Boolean(cutNode)}
                />
            </Paper>
        </React.Fragment>
    );
};

export default TreeCheckListForUser;